/** Session flag set from POST /OnBoarding/login body when `readOnly` is true. */
export const READ_ONLY_SESSION_KEY = "versaOnboardingReadOnly";

export function setSessionReadOnly(readOnly: boolean): void {
  if (readOnly) {
    sessionStorage.setItem(READ_ONLY_SESSION_KEY, "true");
  } else {
    sessionStorage.removeItem(READ_ONLY_SESSION_KEY);
  }
}

export function isSessionReadOnly(): boolean {
  return sessionStorage.getItem(READ_ONLY_SESSION_KEY) === "true";
}

export function clearSessionReadOnly(): void {
  sessionStorage.removeItem(READ_ONLY_SESSION_KEY);
}
